export default function About() {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-white to-orange-50 relative overflow-hidden">
      {/* 배경 장식 */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-orange-100 rounded-full blur-3xl opacity-30"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-orange-50 rounded-full blur-3xl opacity-40"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">회사소개</h2>
          <div className="w-20 h-1 bg-orange-500 mx-auto"></div>
        </div>
        
        <div className="max-w-6xl mx-auto">
          {/* 메인 이미지와 소개 */}
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-orange-500 to-orange-600 rounded-3xl transform rotate-3"></div>
              <img 
                src="https://public.readdy.ai/ai/img_res/b0a295a1ccbc990b046d53b33a05d628.jpg"
                alt="PLAY PLACE 공간"
                className="relative rounded-3xl shadow-2xl w-full h-[400px] object-cover"
              />
            </div>
            
            <div>
              <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-10 mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  PLAY PLACE는 공간을 기반으로 한 놀이 중심 운영 브랜드입니다.
                </h3>
              </div>
              
              <div className="space-y-6">
                <p className="text-lg text-gray-700 leading-relaxed">
                  PLAY PLACE는 특정 결과나 경쟁이 아닌<br />
                  사람들이 자연스럽게 머무르고<br />
                  함께 시간을 보내는 공간을 설계합니다.
                </p>
                
                <p className="text-lg text-gray-700 leading-relaxed">
                  이용자는 부담 없이 참여하고<br />
                  운영자는 공간 운영에 집중할 수 있는<br />
                  단순한 구조를 제공합니다.
                </p>
              </div>
            </div>
          </div>
          
          {/* 핵심 가치 카드 */}
          <div className="grid md:grid-cols-3 gap-10">
            <div className="group bg-white rounded-2xl p-10 shadow-lg border border-gray-100 hover:shadow-2xl hover:scale-105 transition-all duration-300">
              <div className="relative mb-6">
                <div className="w-20 h-20 bg-gradient-to-br from-orange-400 to-orange-600 rounded-2xl flex items-center justify-center mx-auto transform group-hover:rotate-6 transition-transform">
                  <i className="ri-group-line text-4xl text-white"></i>
                </div>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4 text-center whitespace-nowrap">이용자 중심</h4>
              <p className="text-gray-600 text-center leading-relaxed">부담 없이 참여하고<br />자유롭게 머무는 공간</p>
            </div>
            
            <div className="group bg-white rounded-2xl p-10 shadow-lg border border-gray-100 hover:shadow-2xl hover:scale-105 transition-all duration-300">
              <div className="relative mb-6">
                <div className="w-20 h-20 bg-gradient-to-br from-orange-400 to-orange-600 rounded-2xl flex items-center justify-center mx-auto transform group-hover:rotate-6 transition-transform">
                  <i className="ri-store-line text-4xl text-white"></i>
                </div>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4 text-center whitespace-nowrap">운영자 지원</h4>
              <p className="text-gray-600 text-center leading-relaxed">공간 운영에 집중할 수 있는<br />단순한 구조</p>
            </div>
            
            <div className="group bg-white rounded-2xl p-10 shadow-lg border border-gray-100 hover:shadow-2xl hover:scale-105 transition-all duration-300">
              <div className="relative mb-6">
                <div className="w-20 h-20 bg-gradient-to-br from-orange-400 to-orange-600 rounded-2xl flex items-center justify-center mx-auto transform group-hover:rotate-6 transition-transform">
                  <i className="ri-building-line text-4xl text-white"></i>
                </div>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4 text-center whitespace-nowrap">공간 설계</h4>
              <p className="text-gray-600 text-center leading-relaxed">자연스럽게 머무르며<br />시간을 보내는 공간</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}